import Button from "../Button/Button";

type Props = {
  text: string | JSX.Element,
  isDisabled?: boolean,
  fn?: (a?: any) => void,
  eventName?: string,
  actionName?: string,
  icon?: JSX.Element,
  iconPosition?: 'left' | 'right',
  compact?: boolean
};

function SecondaryButton({
    text, 
    fn = () => null, 
    isDisabled = false, 
    eventName = '', 
    actionName,
    icon,
    iconPosition = 'left',
    compact = false
  }: Props) {

  const track = (e: any) => {
    fn();
  }

  return (
    <Button 
      text={
        <>
          {iconPosition === 'left' && icon && <span className="mr-1 flex-shrink-0 dark:[&_img]:invert">{icon}</span>}
          <span className={`${compact && icon ? 'hidden sm:inline' : ''} break-words text-[10px] sm:text-xs md:text-xs lg:text-sm leading-tight max-w-full`}>{text}</span>
          {iconPosition === 'right' && icon && <span className="ml-1 flex-shrink-0 dark:[&_img]:invert">{icon}</span>}
        </>
      } 
      fn={track} 
      isDisabled={isDisabled} 
      cssStyles={`bg-transparent font-light border bg-clip-text bg-gradient-to-r from-amber-300 to-amber-600 hover:text-amber-600 duration-500 py-1 px-1 sm:px-2 md:px-4 lg:px-5 xl:px-6 h-8 sm:h-10 md:h-12 min-w-0 inline-flex items-center justify-center`}
      actionName={actionName}
    />
  );
}

export default SecondaryButton;
